<template>
    <div class="homepage d-flex flex-column vh-100">
         <!-- navbar -->
         <div class="homepage-navbar bg-light shadow mb-auto p-3 bg-primary">
            <div class="d-flex align-items-center">
               <a class="link-dark text-truncate d-flex align-items-center gap-2"  >
                  
                  <div>
                    <h2 class="text-white text-center">Laundry Master</h2>
                  </div>
               
               </a>
         
            </div>
         </div>
         <!--start------------------------------------------------------- body----------------------------------------------------------------------------->

         <!-- Body -->
        <div class="container d-flex flex-column  mt-5 align-items-center flex-grow-1">
            <div class="card p-2 shadow" style="width: 100%; max-width: 400px;">
                <h3 class="text-center mb-3">Register</h3>
                
                <div v-if="!verified">
                <div class="mb-3">
                    <label for="name" class="form-label">Name</label>
                    <input type="text" id="name" v-model="register.name" class="form-control" required>
                </div>

                    <div class="mb-3">
                        <label for="mobile" class="form-label">Mobile No</label>
                        <input type="text" id="mobile" v-model="register.mobile" class="form-control" required>
                    </div>
                    <div class="mb-3">
                        <label for="password" class="form-label">Password</label>
                        <input type="password" id="password" v-model="register.password" class="form-control" maxlength="10" required>
                    </div>

                    <div class="mb-3">
                      <label for="language" class="form-label">Select Language</label>
                      <select id="language" v-model="register.language" class="form-control" required>
                          <option value="English">English</option>
                          <option value="Marathi">Marathi</option>
                      </select>
                  </div>
                  

               

                    <button class="btn btn-primary w-100" @click="userregister">Verify</button>
                 </div>
                 <div v-if="otpverified">
                    <div class="mb-3">
                        <label for="otp" class="form-label">Otp</label>
                        <input type="" id="otp" v-model="verify.otp" class="form-control" required>
                    </div>

                    <button class="btn btn-primary w-100" @click="verifyotp">verify otp</button>
                  </div>
               <!-- <div class="text-center mt-3">
                    <p>Not registered?<router-link :to="'/register'">Create an account</router-link></p>

                </div>  -->
            </div>
        </div>

        <!-- end ---------------------------------------------------------body----------------------------------------------------------------------------->










   

         <!-- footer -->
         <div class="footer bg-white shadow mt-auto border-top">
            <div class="d-flex align-items-center justify-content-center py-1">
                <!--<p style="text-align: center; color: white; margin: 0;">Designed And Developed by DK Techno's</p>-->
            </div>
        </div>
      </div>
</template>
<style>
.weather-container {
  text-align: center;
    font-family: Arial, sans-serif;
    padding: 4px 20px;
    background: #f4f4f4;
    margin: auto;
    border-radius: 10px;
}
.bg_card{
  background: #ededec;
    margin: 10px 0px;
    padding-bottom: 10px;
}
.custom-btn {
    background: linear-gradient(328deg, #ff0000, #000199);
    border: none; /* Remove Bootstrap's default border */
    color: white; /* Ensure text is readable */
}

</style>

<script> 
import axios from "@/plugins/axios";  

export default {
  name: 'HomeView',
  components: { 
  },
  mounted() {
    
     
},
  data() {
    return {
      loading:false,
      error:null,
      verified: false,
      otpverified:false,
      register:
           {
             name:'',
             mobile:'',
             password:'',
             language:'English',
           },
         
           verify:{
            otp:'',
            mobile:''
           }
           
    }
  },
  methods:{
    

      userregister() {
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;
           if(self.register.mobile == ''){
            self.$swal.fire("Enter Mobile"); 
           }else if(self.register.password == ''){
            self.$swal.fire("Enter Password"); 
           }else{
            axios.post("userregister",self.register).then((response) => {
                if(response.data.success == 2){ 
                    this.$router.push('/');
                } 
              self.$swal.fire(response.data.message); 
              self.verify.mobile=self.register.mobile;
              // $sw
              this.verified = true;
              this. otpverified=true;
          }).then(() => {
            
               self.initializeHomeContent();
          }).catch((err) => {
            
          });;
        }

        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      }, 


      verifyotp() {
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;
            axios.post("verifyotp",self.verify).then((response) => {
                 self.$swal.fire(response.data.message);
                if(response.data.success == 1){
                     localStorage.setItem('token',response.data.token);
                     self.$router.push('/registerlaundry');
                }else  if(response.data.success == 2){ 
                     self.$router.push('/');
                }
              
              self.verified = true;
          }).then(() => {
            
               self.initializeHomeContent();
          }).catch((err) => {
            
          });;
         

        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      }, 







  }
}
</script>
